module.exports = "<button class=\"btn {{ mod }}\">{{ text }}</button>";